import { createContext } from 'react'
import type { CartLine } from './types'

export interface CartContextValue {
  lines: CartLine[]
  lineCount: number
  totalCents: number
  addItem: (item: Omit<CartLine, 'quantity'>, quantity?: number) => void
  setQuantity: (menuItemId: number, quantity: number) => void
  removeItem: (menuItemId: number) => void
  clear: () => void
}

export const CartContext = createContext<CartContextValue | null>(null)
